import { Company, createSelector } from "@kanda-libs/ks-frontend-services";
import { selectors } from "store";
import { filterJobs } from "components/job/JobTable/helpers";
import { getQueryFlags } from "./query";

const getJobCompany = createSelector(
  selectors.job.getEntity,
  selectors.company.getEntities,
  (job, companies): Company | undefined => companies[job?.cid as string]
);

const getFilteredJobs = createSelector(
  selectors.job.getEntitiesAsArray,
  selectors.company.getEntitiesAsArray,
  selectors.credit.getEntitiesAsArray,
  getQueryFlags,
  (jobs, companies, credits, flags) =>
    filterJobs(
      jobs,
      flags.jobs.solar,
      flags.jobs.satNoteSigned,
      flags.jobs.pendingPayout,
      companies,
      credits
    ) || []
);

const jobSelectors = {
  ...selectors.job,
  getJobCompany,
  getFilteredJobs,
};

export default jobSelectors;
